export default __webpack_public_path__ + "static/media/ic_binance_logo.3c9a4098.svg";